import { AppButton } from '../../../../shared/ui/button'
import { useStyles } from './styles'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { Icon, TIconVariant } from '../../../../shared/ui/icon'
import { useCallback, useState } from 'react'
import { CasePurchaeCurrency } from '@/entities/cases'

type CaseOpeningConfirmationProps = {
  price: number
  onConfirm: () => void
  onDeny: () => void
  caseName: string
  currency: CasePurchaeCurrency
}

export const CaseOpeningConfirmation = (props: CaseOpeningConfirmationProps) => {
  const userLang = useUnit($userLanguage)
  const { classes } = useStyles()
  const { price, onConfirm, onDeny, caseName } = props
  const btnTexts = lang[userLang].pages.btnTexts
  const [locked, setLocked] = useState<boolean>(false)
  const icon: TIconVariant = props.currency === 'keys' ? 'gamedKey' : 'gamed'
  const handleConfirm = useCallback(() => {
    onConfirm()
    setLocked(true)
  }, [onConfirm])

  return (
    <div className={classes.root}>
      <span className={classes.modalText}>
        {btnTexts.open} {caseName}?
      </span>
      <div className={classes.buttonWrapper}>
        <AppButton variant="secondary" className={classes.backButton} onClick={onDeny}>
          {lang[userLang].pages.btnTexts.back}
        </AppButton>
        <AppButton variant="primary" disabled={locked} className={classes.useButton} onClick={handleConfirm}>
          {lang[userLang].pages.btnTexts.use} {price}
          &nbsp;
          <Icon view={icon} width={16} />
        </AppButton>
      </div>
    </div>
  )
}
